import { PaymentStatusEnum } from '../../enums';
import { Option } from '../../type';

export const LICENSE_STATUS_OPTIONS: Option<PaymentStatusEnum>[] = [
  { label: 'Active', value: PaymentStatusEnum.Active },
  { label: 'Expired', value: PaymentStatusEnum.Expired },
  { label: 'Pending', value: PaymentStatusEnum.Pending }
];
